<template>
  <div>
    <section class="band not-found">
      <div class="container container--narrow">
        <p class="code tabular" aria-hidden="true">404</p>
        <h1>Cette page n'existe pas</h1>
        <p class="lead">L'adresse a peut-être changé, ou le lien est incomplet. Voici où continuer :</p>
        <ul class="exits">
          <li><router-link to="/">L'accueil de Citron Digital</router-link></li>
          <li><router-link to="/gestionnaire-citron">Le Gestionnaire Citron, logiciel de devis et factures</router-link></li>
          <li><router-link to="/blog">Les guides sur la facturation électronique</router-link></li>
          <li><router-link to="/contact">Nous contacter</router-link></li>
        </ul>
      </div>
    </section>
  </div>
</template>

<script>
  import {useSeo} from "@/seo/useSeo";

  /**
   * Page d'erreur : jamais indexée. Le serveur de fichiers renvoie le même index.html pour toute adresse inconnue (voir README).
   */
  export default {
    name: 'NotFoundView',
    setup() {
      useSeo({
        path: '/404',
        title: 'Page introuvable | Citron Digital',
        description: 'Cette page n\'existe pas ou a changé d\'adresse.',
        noindex: true
      });
    }
  }
</script>

<style lang="stylus" scoped>
@import '~/src/common/style/constants.styl';

.not-found
  min-height 60vh

.code
  margin 0
  font-family 'Calder-LC', 'Trebuchet MS', system-ui, sans-serif
  font-size clamp(4rem, 14vw, 8rem)
  line-height 1
  color INK
  background linear-gradient(transparent 62%, LEMON 62%)
  display inline-block
  padding 0 0.1em

h1
  margin-top 16px

.lead
  margin-top 16px

.exits
  margin 28px 0 0
  padding 0
  list-style none
  border-top 2px solid INK
  li
    margin 0
    padding 14px 0
    border-bottom 1px solid RULE
  a
    font-weight 650
</style>
